import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SimpleInputDropdown from '../../../components/SimpleInputDropdown';
import { handleDropdownSelection, getDropdownDisplayProps } from '../../../utils/Utils';

export default class InputDropDown extends Component {
    static propTypes = {
        values: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                key: PropTypes.string
            })
        ).isRequired,
        defaultValue: PropTypes.string.isRequired,
        currentValue: PropTypes.string,
        className: PropTypes.string,
        hasEmptyValue: PropTypes.bool,
        multiSelect: PropTypes.bool,
        defaultSelectedValues: PropTypes.arrayOf(PropTypes.string),
        onChangeValue: PropTypes.func
    };

    static defaultProps = {
        hasEmptyValue: true,
        multiSelect: false,
        defaultSelectedValues: [],
        onChangeValue: () => { }
    };

    state = {
        selectedValue: '',
        selectedValues: this.props.defaultSelectedValues || []
    };

    componentDidUpdate(prevProps) {
        // Sync state with props when defaultSelectedValues change
        if (JSON.stringify(prevProps.defaultSelectedValues) !== JSON.stringify(this.props.defaultSelectedValues)) {
            this.setState({ selectedValues: this.props.defaultSelectedValues || [] });
        }
    }

    onDropdownItemClick = (index) => {
        const result = handleDropdownSelection({
            index,
            values: this.props.values,
            multiSelect: this.props.multiSelect,
            selectedValues: this.state.selectedValues,
            onChangeValue: this.props.onChangeValue
        });

        if (this.props.multiSelect) {
            this.setState({ selectedValues: result.selectedValues });
        } else {
            this.setState({ selectedValue: result.selectedValue });
        }
    };

    render() {
        // Handle missing names by showing "Unknown name (CODE)"
        const options = this.props.values.map((e) => {
            const displayName = e.name || `Unknown name (${e.value || 'N/A'})`;
            return { label: displayName, key: e.name || e.value };
        });

        const { text, badgeCount, hasEmptyValue } = getDropdownDisplayProps({
            multiSelect: this.props.multiSelect,
            selectedValue: this.state.selectedValue,
            selectedValues: this.state.selectedValues,
            defaultValue: this.props.defaultValue,
            hasEmptyValueProp: this.props.hasEmptyValue
        });

        return (
            <SimpleInputDropdown
                text={text}
                badgeCount={badgeCount}
                options={options}
                className={this.props.className}
                isScrollable={true}
                isInput={true}
                hasEmptyValue={hasEmptyValue}
                multiSelect={this.props.multiSelect}
                selectedValues={this.state.selectedValues}
                onChangeValue={(index, label) => this.onDropdownItemClick(index, label)}>
                {this.props.children}
            </SimpleInputDropdown>
        );
    }
}
